import axios from 'axios'

let urlENV = null

const getApi = ({ url }, key = null) => {
  switch (key) {
    case null:
      urlENV = process.env.VUE_APP_URL_BASE
      break
    case 'users':
      urlENV = process.env.VUE_APP_URL_USERS
      break
    case 'education':
      urlENV = process.env.VUE_APP_URL_EDUCATION
      break
    default:
      urlENV = process.env.VUE_APP_URL_BASE
  }
  const request = axios.get(`${urlENV}${url}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.token || sessionStorage.token}`
      },
      withCredentials: true
    })
  return request.then((response) => {
    return response.data
  })
}

const postApi = ({ url, payload }, key = null) => {
  switch (key) {
    case null:
      urlENV = process.env.VUE_APP_URL_BASE
      break
    case 'users':
      urlENV = process.env.VUE_APP_URL_USERS
      break
    case 'education':
      urlENV = process.env.VUE_APP_URL_EDUCATION
      break
    default:
      urlENV = process.env.VUE_APP_URL_BASE
  }
  const request = axios.post(`${urlENV}${url}`, payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.token || sessionStorage.token}`
      },
      withCredentials: true
    }
  )
  return request.then((response) => {
    return response.data
  })
}

const putApi = ({ url, payload }, key = null) => {
  switch (key) {
    case null:
      urlENV = process.env.VUE_APP_URL_BASE
      break
    case 'users':
      urlENV = process.env.VUE_APP_URL_USERS
      break
    case 'education':
      urlENV = process.env.VUE_APP_URL_EDUCATION
      break
    default:
      urlENV = process.env.VUE_APP_URL_BASE
  }
  const request = axios.put(`${urlENV}${url}`, payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.token || sessionStorage.token}`
      },
      withCredentials: true
    }
  )
  return request.then((response) => {
    return response.data
  })
}

const deleteApi = ({ url }, key = null) => {
  switch (key) {
    case null:
      urlENV = process.env.VUE_APP_URL_BASE
      break
    case 'users':
      urlENV = process.env.VUE_APP_URL_USERS
      break
    case 'education':
      urlENV = process.env.VUE_APP_URL_EDUCATION
      break
    default:
      urlENV = process.env.VUE_APP_URL_BASE
  }
  const request = axios.delete(`${urlENV}${url}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.token || sessionStorage.token}`
      },
      withCredentials: true
    }
  )
  return request.then((response) => {
    return response.data
  })
}

export {
  getApi,
  postApi,
  putApi,
  deleteApi
}
